// extracted by mini-css-extract-plugin
export default {"select":"simpleSelect_select__dMnWF","positionContainer":"simpleSelect_positionContainer__hP0bN","positionLabel":"simpleSelect_positionLabel__GLNX7"};